import './stack.css';
export default {
  "modifiers": {
    "fill": "pf-m-fill",
    "gutter": "pf-m-gutter"
  },
  "stack": "pf-v5-l-stack",
  "stackItem": "pf-v5-l-stack__item"
};